import { render, staticRenderFns } from "./DraggableHeaderTable.vue?vue&type=template&id=16ca3705"
import script from "./DraggableHeaderTable.vue?vue&type=script&lang=js"
export * from "./DraggableHeaderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports